<script>
import { mapState } from "vuex";
import Toasts from "@/components/Toasts";
import Header from "@/components/Header";

import "@/global.css";

export default {
  components: {
    Toasts,
    Header,
  },

  computed: {
    ...mapState(["activeTeamId"]),
  },
};
</script>

<template>
  <div id="app">
    <Toasts />
    <Header :key="activeTeamId">
      <router-view />
    </Header>
  </div>
</template>
